<template>
  <v-dialog
      v-model="showModal"
      max-width="450"
      persistent
      content-class="no-scroll-dialog"
  >
    <v-card>
      <v-card-title v-if="title" class="title-modal">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div v-if="bannerUrl" class="text-center pt-4">
          <a
              :href="externalLink"
              target="_blank"
              v-if="externalLink"
              class="banner-link"
          >
            <v-img
                :src="bannerUrl"
                :aspect-ratio="0.8889"
                class="mx-1 mt-4"
                max-width="100%"
            ></v-img>
          </a>
          <v-img
              v-else
              :src="bannerUrl"
              :aspect-ratio="0.8889"
              class="mx-1"
              max-width="100%"
          ></v-img>
        </div>
      </v-card-text>
      <v-card-actions class="flex-column">
        <v-btn
            v-if="externalLink"
            class="mx-0 mt-0"
            color="primary"
            block
            height="48"
            @click="openLink"
        >
          <span class="font-weight-bold">Saiba mais</span>
        </v-btn>
        <v-btn
            class="mx-0 mt-2"
            color="error"
            block
            height="48"
            @click="onClose"
        >
          <span class="font-weight-bold">Fechar</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CampaignModal',
  props: {
    userId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showModal: false,
      bannerId: null,
      bannerUrl: null,
      externalLink: null
    };
  },
  mounted() {
    this.getBanner();
  },
  methods: {
    async getBanner() {
      try {
        const response = await axios.get(`/api/app/banner/view/${this.userId}`);
        const data = response.data;
        if (data && data.id) {
          this.bannerId = data.id;
          this.bannerUrl = data.url;
          this.externalLink = data.external_link;
          this.showModal = true;
        }
      } catch (error) {
        return;
      }
    },
    async updateBanner(bannerId, userId) {
      return await axios.put(`/api/app/banner/save/${bannerId}/${userId}`);
    },
    async onClose() {
      try {
        if (this.bannerId) {
          await this.updateBanner(this.bannerId, this.userId);
        }
      } catch (error) {
        return;
      } finally {
        this.showModal = false;
      }
    },
    openLink() {
      if (this.externalLink) {
        window.open(this.externalLink, '_blank');
      }
    }
  }
};
</script>

<style scoped>
.title-modal {
  word-break: normal;
  text-align: center;
  margin: auto;
  padding: 20px;
}

.banner-link {
  text-decoration: none;
  display: block;
  cursor: pointer;
}

.no-scroll-dialog {
  overflow-y: hidden;
}

.v-card {
  max-height: 95vh;
  margin-top: auto;
}

</style>
